// extracted by mini-css-extract-plugin
export default {"card":"IDCard_card__Zqdty","copy":"IDCard_copy__aYT+M","header":"IDCard_header__rkmDp","img":"IDCard_img__k2rXB","led":"IDCard_led__G0iEa"};